// Where the browser reaches the bridge API (PRD 009 §4.5). The hosted model is now
// SAME-ORIGIN: the SPA and the bridge Worker share one host per env
// (www.convariance.com prod / www.convariance.dev dev), the Worker carves out the API
// paths — so the base is empty (relative /bridge/* URLs), exactly like the local
// gateway that serves the SPA itself. Resolution order, with a Settings override:
//
//   user override (keys.bridgeUrl)  →  build-time VITE_BRIDGE_API_ORIGIN  →  ''
//
// '' means same-origin (the hosted default now AND the self-host-on-loopback path).
// VITE_BRIDGE_API_ORIGIN is only set when pointing a SPA at a DIFFERENT bridge.

export const BRIDGE_API_ORIGIN = (import.meta.env.VITE_BRIDGE_API_ORIGIN ?? '')
  .trim()
  .replace(/\/+$/, '')

/** Resolve the effective bridge origin: an explicit Settings override wins, else
 *  the build-time hosted origin, else '' (same-origin). */
export function resolveBridgeEndpoint(bridgeUrl?: string | null): string {
  return bridgeUrl?.trim() || BRIDGE_API_ORIGIN || ''
}
